import makeSlice from '@web/slices/mobile/sliceMaker'

const slice = makeSlice()

export default slice.reducer
